'use es6';

export default {
  MISSING_PERMISSION: 'MISSING_PERMISSION',
  ACTIVE_DOWNGRADE: 'ACTIVE_DOWNGRADE',
  REDIRECT_DOMAIN: 'REDIRECT_DOMAIN',
  NOT_CONTENT_HOSTING: 'NOT_CONTENT_HOSTING'
};